var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Revealer = require('../../lib/revealer.js');
var RoleAssigner = require('./markers/role-assigner.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
    var marker = new Marker('users');

    new IndexView();

    new Deletism(marker);
    new Undeletism(marker);
    new RoleAssigner(marker, new Revealer);

    new Columnator();
};
